import React from 'react'
import Edit from '../crud/edit'
import menuItems from './menuItems'

const fields = [
  {
    name: 'Global CSS',
    prop: 'value',
    type: 'textarea'
  }
]

const EditSettings = (props) => {
  return (
    <Edit
// @ts-ignore
      title='Edit Global CSS'
      fields={fields}
      apiPath='admin/settings/global_css'
      successRedirectPath='/settings'
      buildMenuItems={menuItems}
      disableDelete
    />
  )
}

export default EditSettings
